const defaultFood = {
  name: "",
  description: "",
  note: "",
  category: "",
  sizes: [],
  cena: "",
  price: 0,
  groceries: [],
  code: null,
  prilog: [],
  type: [],
  attachments: [],
  selectedPrices: [],
  labels: [],
  translations: [],
};

const defaultGrocery = {
  name: "",
  measure: "",
  code: "",
  min_quantity: "",
};

export { defaultFood, defaultGrocery };
